/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
 */

/**
 * Resolves the reading direction used for layout and focus order.
 * Interaction-level `dir` takes precedence, then item-level direction from context.
 * @param {string} [dir] - Direction set on the interaction element.
 * @param {string} [_language] - Interaction language (unused; item context provides direction).
 * @param {object} [itemContext] - Item context from Svelte context.
 * @returns {string|undefined} `"rtl"`, `"ltr"`, or `undefined`.
 */
export function getFlowDirection(dir, _language, itemContext) {
    return dir || (itemContext && itemContext.getItemDir && itemContext.getItemDir()) || void 0;
}
